export default __webpack_public_path__ + "005f5b47c844f61f5b97f08f36f2d921.jpg";